import React from "react";
import styled from "styled-components";

import { MatchDraft } from "../components";

const MatchDetailSection = ({ match, divisionName }) => {
  const summary = `${match.comments}`;
  return (
    <Wrapper>
      <div className="matches">
        <div className="result">
          {match.status === "NOT_STARTED" ? (
            <div>
              <div>
                {match.match_date
                  ? new Date(match.matchDate).toLocaleString("es-ES", {
                      timeZone: "Europe/Madrid",
                    })
                  : "Pendiente fecha"}

                <MatchDraft match={match} divisionName={divisionName} />
              </div>
            </div>
          ) : (
            <div>
              <h1>{`${match.playerAresult} ${
                match.playerAaw ? match.playerAaw : ""
              } : ${match.playerBresult}  ${
                match.playerBaw ? match.playerBaw : ""
              }`}</h1>
              <p className="draft-links">
                Draft de mapas:
                <br />
                <a
                  href={match.mapDraft}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {match.mapDraft}
                </a>
              </p>
              <p className="draft-links">
                Draft de civis: <br />
                <a
                  href={match.civDraft}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {match.civDraft}
                </a>
              </p>
              <textarea
                readonly
                className="input-text-field-large"
                type="text"
                placeholder="Comentarios"
                value={summary}
                name="comments-finished-match"
              />
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .draft-links {
    font-size: 16px;
  }
  .input-text-field-large {
    pointer-events: none;
    background: transparent;
    width: 30rem;
    height: 280px;
    border: 1px solid var(--clr-grey-1);
    padding: 0.2rem;
    outline: 0;
    color: var(--clr-grey-1);

    transition: border-color 0.2s;
  }
  .matches {
    display: flex;
    justify-content: center;
    flex-direction: column;
    h1 {
      text-align: center;
    }
    h1 div p {
      display: flex;
      justify-content: center;
    }
  }
  @media (max-width: 800px) {
    .input-text-field-large {
      width: 20rem;
    }
  }
`;

export default MatchDetailSection;
